import { WebshopShoppingCartEndpoint as WebshopShoppingCartEndpointInterface } from '@apiClient/interfaces/endpoints/WebshopShoppingCart.endpoint';
import ApiResponseDto from '@apiClient/interfaces/response/ApiResponse.dto';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import CartStateDto from '@/projectRoot/api-client/interfaces/models/cart/CartState.dto';
import CartDto from '@/projectRoot/api-client/interfaces/models/cart/Cart.dto';

export class WebshopShoppingCartEndpoint implements WebshopShoppingCartEndpointInterface {

    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * /api/webshop/shopping-cart/processed
    */
    async processed(state: CartStateDto): Promise<ApiResponseDto<CartDto, undefined>> {
        return this._httpClient
            .post(`webshop/shopping-cart/processed`, { json: state, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CartDto, undefined> = await kyResponse.json();
                return response;
            });
    }
}

export default WebshopShoppingCartEndpoint;